$.fn.hasAttr = function (name) {
	return this.attr(name) !== undefined;
};
var currCulture = "vi";
let DateTime = luxon.DateTime;
if ($("html").attr("lang") == "en") currCulture = "en";
var lang = {};
lang["en"] = {
	languageType: "en",
	percentTxt: "Percent",
};
lang["vi"] = {
	languageType: "vi",
	percentTxt: "Tỉ lệ",
};

// ******* Global Variable s*******

// *** Window
var ww = $(window).width();
var body = $("body");
// *** Header *** //
var header = $("header");
var height_header = header.outerHeight();
var menu_nav = header.find("nav");
var burger = header.find("#burger");
var overlay = $("#overlay");
// *** Nav Moble *** //
var nav_mobile = $(".nav-mobile");
var ul_Child = nav_mobile.find(".has-child");
var close_NB = nav_mobile.find("#close-button");
// *** Banner *** //
var pagesBanner = $("#page-banner");
var mainBanner = $("#main-banner");
// *** Footer *** //
$(".search-overlay").removeClass("active");
var mainSection = $("main");
var footer = $("footer");
// *** Component *** //
// Search
var btn_BackToTop = $("#back-to-top");

const setLineFirstTime = (liActive) => {
	if (liActive?.offset()?.left) {
		var line = header.find(".line");
		line.css({
			left: liActive.offset().left + "px",
			width: liActive.width() + "px",
		});
	}
};
const headerFunction = {
	onScroll: () => {
		var lastScrollTop = 0;
		$(window).on("scroll", function () {
			var st = $(this).scrollTop();
			if (st > lastScrollTop && st > height_header) {
				header.addClass("header-scroll");
				$(".search-overlay").addClass("header-scroll");
			} else {
				header.removeClass("header-scroll");
				$(".search-overlay").removeClass("header-scroll");
			}
			lastScrollTop = st;
			// removeSearch();
		});
	},
	movingLineOnLiActive: () => {
		var line = header.find(".line");
		var offset = header.find("nav").offset().left;
		var nav = header.find("nav");
		var liActive = header.find("li[class*='current']");
		if ($(".menu-item-387").length && $(".tax-documents").length) {
			header.find("li.menu-item-387").addClass("active");
			liActive = header.find("li.menu-item-387");
		}

		setLineFirstTime(liActive);
		setTimeout(() => {
			line.addClass("active");
		}, 350);
		var oldOffset, oldWidth;
		if (liActive.length) {
			oldOffset = liActive.offset().left;
			oldWidth = liActive.width();
			nav.on("mouseenter", function () {
				var li = $(this).find("li");
				li.on("mousemove", function () {
					line.css({
						left: $(this).offset().left + "px",
						width: $(this).width() + "px",
					});
				});
				li.on("click", function () {
					line.css({
						left: $(this).offset().left + "px",
						width: $(this).width() + "px",
					});
					oldOffset = $(this).offset().left;
					oldWidth = $(this).width();
				});
			});
			nav.on("mouseleave", function () {
				line.css({
					left: oldOffset + "px",
					width: oldWidth + "px",
				});
			});
		}
	},
	navMobileSlide: () => {
		burger.on("click", function () {
			burger.toggleClass("active");
			nav_mobile.toggleClass("active");
			overlay.toggleClass("active");
			body.toggleClass("ovh");
			header.toggleClass("navMobileOpen");
			$(".search-overlay").removeClass("active");
		});
		overlay.on("click", function () {
			burger.removeClass("active");
			nav_mobile.removeClass("active");
			overlay.removeClass("active");
			body.removeClass("ovh");
			header.removeClass("navMobileOpen");
			$(".search-overlay").removeClass("active");
		});
	},
	navMobileChild: () => {
		var liChild = nav_mobile.find("li.menu-item-has-children > a");
		//
		liChild.each(function () {
			$(this).attr("state", "unClick");
		});
		liChild.on("click", function (e) {
			if ($(this).attr("state") === "unClick") {
				e.preventDefault();
				// console.log("unclick");
				$(this)
					.closest("ul")
					.find("li.menu-item-has-children > a")
					.attr("state", "unClick");
				$(this)
					.closest("ul")
					.find("li.menu-item-has-children > a")
					.siblings()
					.slideUp();
				$(this).attr("state", "click");
				$(this).siblings().slideDown();
			} else {
				// console.log("click, page direction to" + $(this).attr("href"));
			}
		});
	},
	searchActive: () => {
		//
		$(".search-icon").on("click", function () {
			$(".search-overlay").addClass("active");
			header.addClass("navMobileOpen");
			setTimeout(() => {
				$(".search-overlay .searchbox input").trigger("focus");
			}, 500);
		});
		$(".search-overlay .searchbox input").on("focus", function () {
			$(this).parent().addClass("active");
		});
		$(".search-overlay .searchbox input").on("focusout", function () {
			$(this).parent().removeClass("active");
		});
		$(document).on("click", function (event) {
			var $trigger = $("header");
			var $trigger_2 = $(".search-overlay");
			if (
				$trigger !== event.target &&
				!$trigger.has(event.target).length &&
				$trigger_2 !== event.target &&
				!$trigger_2.has(event.target).length
			) {
				$(".search-overlay").removeClass("active");
				header.removeClass("navMobileOpen");
			}
		});
		$(".search-overlay .searchinput").keyup(function () {
			$(".search-overlay .wrapper").addClass("fixed-title");
			if ($(this).val() == "") {
				$(".search-overlay .wrapper").removeClass("fixed-title");
			}
		});
		// Press ESC to close Search
		setTimeout(() => {
			$(window).on("keyup", function (event) {
				var e = event.keyCode;
				if (e == 27) {
					$(".search-overlay").removeClass("active");
				}
			});
		}, 500);

		// Trigger click with 2 button
		$(".search-overlay .searchbox input[type='text']").keypress(function (
			n
		) {
			if (n.keyCode == 13)
				$(".searchbox button").trigger("click"), console.log("click");
		});
	},
	escBtn: () => {
		$(window).on("keyup", function (event) {
			var e = event.keyCode;
			if (e == 27) {
				nav_mobile.removeClass("active");
				header.removeClass("blur-content");
				burger.removeClass("active");
				overlay.removeClass("active");
				body.removeClass("ovh");
				header.removeClass("navMobileOpen");
			}
		});
	},
	init: () => {
		headerFunction.onScroll();
		headerFunction.navMobileSlide();
		headerFunction.navMobileChild();
		headerFunction.searchActive();
		headerFunction.escBtn();
	},
};

var index_3_chart;
var index_3_post_id = [];
function swiperInit() {
	var main_banner = new Swiper("#main-banner .swiper", {
		spaceBetween: 0,
		autoplay: {
			delay: 4500,
		},
		effect: "creative",
		creativeEffect: {
			prev: {
				shadow: true,
				translate: ["-20%", 0, -1],
			},
			next: {
				translate: ["100%", 0, 0],
			},
		},
		speed: 500,
		observer: true,
		observeParents: true,
		pagination: {
			el: "#main-banner .swiper-pagination",
		},
		navigation: {
			prevEl: "#main-banner .swiper-button-prev",
			nextEl: "#main-banner .swiper-button-next",
		},
	});
	index_3_chart = new Swiper(".index-3 .swiper", {
		speed: 500,
		navigation: {
			prevEl: ".index-3 .swiper-button-prev",
			nextEl: ".index-3 .swiper-button-next",
		},
		slidesPerView: 1,
		spaceBetween: 10,
		on: {
			afterInit: function () {
				index_3_post_id = $(".index-3 .swiper-slide")
					.eq(this.activeIndex)
					.attr("post-id");
			},
		},
	});
	var index_4 = new Swiper(".index-4 .swiper", {
		speed: 500,
		navigation: {
			prevEl: ".index-4 .swiper-button-prev",
			nextEl: ".index-4 .swiper-button-next",
		},
		breakpoints: {
			1280: {
				slidesPerView: 5,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			576: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
			320: {
				slidesPerView: 2,
				spaceBetween: 5,
			},
		},
		on: {
			init: function (swiper) {
				toggleCenterSlideActive(swiper);
			},
			resize: function (swiper) {
				if (!swiper || !swiper.$el) return;
				toggleCenterSlideActive(swiper);
			},
		},
	});
	function toggleCenterSlideActive(swiper) {
		const totalSlidesWidth = swiper.slidesSizesGrid.reduce(
			(acc, curr) => acc + curr,
			0
		);
		swiper.$el[0].classList.toggle(
			"center-slide-active",
			totalSlidesWidth < swiper.size
		);
	}

	$(".thongtinquy-5").each(function (e) {
		const name = "thong-tin-quy-" + e;
		$(this).addClass(name);
		var thongtinquy_5 = new Swiper(`.${name} .swiper`, {
			speed: 500,
			navigation: {
				prevEl: `.${name} .swiper-button-prev`,
				nextEl: `.${name} .swiper-button-next`,
			},
			breakpoints: {
				1280: {
					slidesPerView: 4,
					spaceBetween: 30,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
				576: {
					slidesPerView: 2,
					spaceBetween: 10,
				},
				320: {
					slidesPerView: 2,
					spaceBetween: 5,
				},
			},
		});
	});

	// **** Product **** //
	var product_other = new Swiper(".other-article-slide .swiper", {
		speed: 500,
		navigation: {
			prevEl: ".other-article-slide .swiper-button-prev",
			nextEl: ".other-article-slide .swiper-button-next",
		},
		breakpoints: {
			1280: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 15,
			},
			576: {
				slidesPerView: 2,
				spaceBetween: 15,
			},
			320: {
				slidesPerView: 2,
				spaceBetween: 5,
			},
		},
	});
}

function autoSlideNextOnThumbSlide(initSwiper, element, thumb) {
	let activeIndex = initSwiper.activeIndex + 1;
	let activeSlide = document.querySelector(
		`${element} ${thumb} .swiper-slide:nth-child(${activeIndex})`
	);
	let nextSlide = document.querySelector(
		`${element} ${thumb} .swiper-slide:nth-child(${activeIndex + 1})`
	);
	let prevSlide = document.querySelector(
		`${element} ${thumb} .swiper-slide:nth-child(${activeIndex - 1})`
	);

	if (nextSlide && !nextSlide.classList.contains("swiper-slide-visible")) {
		initSwiper.thumbs.swiper.slideNext();
	} else if (
		prevSlide &&
		!prevSlide.classList.contains("swiper-slide-visible")
	) {
		initSwiper.thumbs.swiper.slidePrev();
	}
}

function expandItem() {
	// Filter Load
	var hasLoadBtn = $("[has-expand-btn]");
	hasLoadBtn.each(function () {
		var $this = $(this);
		var expandBtn = $(this).find(".expand-btn");
		var list = $(this).find(".expand-item").length;
		var count;
		var countMobile = $(this).attr("item-count-mobile");
		countMobile != undefined && countMobile != 0 && ww < 576
			? (count = Number($(this).attr("item-count-mobile")))
			: (count = Number($(this).attr("item-count")));
		var expand = Number($(this).attr("item-expand"));

		//=// Init
		function init(initValue, thisFunction) {
			if (list >= initValue) {
				thisFunction
					.find(".expand-item")
					.slice(0, initValue)
					.slideDown({
						complete: function () {
							$(this).addClass("done-animated");
						},
					});
			} else {
				thisFunction.find(".expand-item").slideDown();
				thisFunction.find(".expand-item").addClass("done-animated");
			}
			if (list == 0 || list <= initValue) {
				expandBtn.hide();
			}
		}
		init(count, $this);

		// Click
		function expandBtnInit(initCount, thisFunction) {
			count = initCount + expand <= list ? initCount + expand : list;
			thisFunction
				.closest(hasLoadBtn)
				.find(".expand-item")
				.slice(0, count)
				.slideDown({
					complete: function () {
						$(this).addClass("done-animated");
					},
				});
			// console.log(count);
			if (count == list) {
				thisFunction.slideUp();
			}
		}
		expandBtn.on("click", function (e) {
			e.preventDefault();
			expandBtnInit(count, $(this));
		});
	});
}

const globalJS = {
	autoFillNoImage: () => {
		setTimeout(() => {
			$("img").each(function () {
				if ($(this).hasAttr("data-src")) {
					if ($(this).attr("data-src") === "") {
						$(this).attr("data-src", "/no-image.png");
						$(this).attr("src", "/no-image.png");
						$(this).addClass("noImage");
					}
				} else if ($(this).hasAttr("src")) {
					if ($(this).attr("src") === "") {
						$(this).attr("src", "/no-image.png");
						$(this).addClass("noImage");
					}
				}
			});
		}, 150);
	},
	autoAppend: () => {
		var appendId = $("[id*='autoAppend-']");
		appendId.each(function (e) {
			var id = $(this).attr("id").slice(11);
			// console.log(id);
			$(this).appendTo("[id*='autoAppendHere-" + id + "']");
			var curHeight = $(this).get(0).scrollHeight;
		});
	},
	autoClone: () => {
		var cloneId = $("[id*='autoClone-']");
		cloneId.each(function (e) {
			var id = $(this).attr("id").slice(10);
			// console.log(id);
			$(this)
				.clone()
				.appendTo("[id*='autoCloneHere-" + id + "']");
		});
	},
	setBackground: () => {
		var position = ["", "top", "left", "right", "bottom"];
		jQuery.each(position, function (index, item) {
			//
			//
			$(`[setBackground${item}]`).each(function () {
				var background = $(this).attr("setBackground" + item);
				$(this).css({
					"background-size": "cover",
					"background-position": `${item} center`,
					"background-image": `url(${background})`,
				});
			});
		});
	},
	scrollToTop: () => {
		$(window).on("scroll", function () {
			if (
				$(this).scrollTop() >= mainBanner.outerHeight() ||
				$(this).scrollTop() >= pagesBanner.outerHeight()
			) {
				btn_BackToTop.addClass("active");
			} else {
				btn_BackToTop.removeClass("active");
			}
		});
		btn_BackToTop.on("click", function () {
			$("html,body").animate({
				scrollTop: 0,
			});
		});
	},
	changeHeaderStyle: () => {
		// console.log(mainBanner.length);
		if (mainBanner.length == 0 && pagesBanner.length == 0) {
			header.addClass("changeStyle");
		}
		if (pagesBanner.length == 0 && mainBanner.length == 0) {
			header.addClass("changeStyle");
			$("main").addClass("space-top");
		}
	},
	inputButtonSubmit: () => {
		$("input[type='submit']").each(function () {
			if ($(this).parent().is(".btn")) {
				//
				$(this).parent().addClass("has-input-submit");
				$(this).parent().attr("data-title", $(this).val());
			}
		});
	},
	init: () => {
		globalJS.autoFillNoImage();
		globalJS.autoAppend();
		globalJS.autoClone();
		globalJS.setBackground();
		globalJS.scrollToTop();
		globalJS.changeHeaderStyle();
		globalJS.inputButtonSubmit();
	},
};

function counterUpNumber() {
	$(".counter").counterUp({
		delay: 10,
		time: 1000,
	});
}

function activeCommonNav() {
	if ($(".children-nav").length) {
		$(".children-nav nav").scrollTo("li.active", 0);
	}
	if ($(".tab-investment").length) {
		$(".tab-investment nav ul").scrollTo("li.active", 0);
		$(".tab-investment .filter").scrollTo("a.active", 0);
	}
}

function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

var prevYear = function (dateObj) {
	var tempDateObj = new Date(dateObj);

	if (tempDateObj.getMonth) {
		tempDateObj.setMonth(tempDateObj.getMonth() - 1);
	} else {
		tempDateObj.setYear(tempDateObj.getYear() - 1);
		tempDateObj.setMonth(12);
	}

	return tempDateObj;
};

function getDynamicPreviousMonth(currentDate, currentMonth) {
	const date = new Date(currentDate);
	const month = date.getMonth() + 1;
	const day = date.getDay();
	const year = date.getFullYear();
	// console.table("🤌 ~ getDynamicPreviousMonth ~ month", { day, month, year });
	for (let i = 0; i < 12; i++) {
		let months = Math.abs(i - month);
		if (months === 0) {
			months = 12;
		}
		// console.log("🤌 ~ getDynamicPreviousMonth ~ months", months);
	}
}
function tabsletSetting() {
	$('[data-toggle="tabslet"]').each(function () {
		$(this)
			.find(`.tab-content`)
			.each(function () {
				$(this).find(`.tabslet-content`).first().show();
				$(this).find(`.tabslet-content-other`).first().show();
			});
	});
	$('[data-toggle="tabslet"]').on("_before", function (e) {
		var id = $(e.target).find("a").attr("href");

		if (id.indexOf("#") == -1) return;
		$(this).find(`.tabslet-content`).css({ display: "none" });
		$(this).find(`.tabslet-content${id}`).show();
		$(this).find(`.tabslet-content-other`).css({ display: "none" });
		$(this).find(`.tabslet-content-other${id}`).show();
		// console.log(`.tabslet-content-other${id}`);
	});
	$(".tabslet-tab a").on("click", function (e) {
		var id = $(e.target).attr("href");
		setTimeout(() => {
			activeCommonNav();
		}, 300);
	});
}

function convertCurrency(num) {
	if (num % 1 !== 0) {
		// num has a fractional part, so create a formatter with at least one fractional digit
		const formatter = new Intl.NumberFormat("de-DE", {
			minimumFractionDigits: 1,
		});
		return (num = formatter.format(num));
	} else {
		// num is an integer, so create a formatter with no fractional digits
		const formatter = new Intl.NumberFormat("de-DE", {
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		});
		return (num = formatter.format(num));
	}
}

function convertNumberFormat(num) {
	if (!num) return num;
	if (isNaN(num)) return num;
	if (typeof num === "string") return num;
	if (Number.isInteger(num)) {
		return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",0";
	}

	return num
		.toString()
		.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
		.replace(".", ",");
}

// Pie Chart

var pieChart;
var pieColors = [
	"#061938",
	"#BDA143",
	"#bdc3c7",
	"#ED8F03",
	"#8C8C8C",
	"#404040",
	"#326CC4",
	"#2056A9",
	"#122F5B",
	"#F6E18D",
	"#EFD066",
	"#DCBB4D",
	"#A89142",
	"#FFB75E",
	"#F7971E",
];
var pieChartRootData = [
	{
		title: "Ngành",
		dates: [
			{
				id: 1,
				dateTime: new Date(),
				data: [
					{
						labels: "Loading...",
						data: 50.5,
					},
					{
						labels: "Loading...",
						data: 1,
					},
					{
						labels: "Loading 2...",
						data: 47.56,
					},
				],
			},
		],
	},
	{
		title: "Loại tài sản",
		dates: [
			{
				id: 1,
				dateTime: new Date(),
				data: [
					{
						labels: "Loading...",
						data: 100,
					},
				],
			},
		],
	},
];
const getPieChartValue = (data, dataType) => {
	var value = [];
	if (!data) return value;
	data.forEach(function (obj, i) {
		value.push(obj[dataType]);
	});
	return value;
};
const PIE_OFFSET = 12;
const convertToValidPieData = (data) => {
	return {
		labels: getPieChartValue(data.data, "labels"),
		datasets: [
			{
				data: getPieChartValue(data.data, "data"),
				backgroundColor: pieColors,
				hoverOffset: PIE_OFFSET,
			},
		],
	};
};
window.doughnutChart = [];
function pieChartInit() {
	let cutoutOffsets = [];
	$(".chart-item").each(function (e) {
		const data = pieChartRootData[e] ? pieChartRootData[e].dates[0] : [];
		const currentData = data;
		const wrapperDom = $(this).closest(".chart-ratio");
		let chartWidth = wrapperDom.width();
		if (chartWidth === 0) {
			chartWidth = 1;
		}
		// console.log("🟩 ~ chartWidth:", chartWidth);
		let cutoutOffset = 78;
		cutoutOffsets.push(cutoutOffset);

		const config = {
			type: "doughnut",
			options: {
				animation: {
					onProgress: function (context) {
						const progress = context.currentStep / context.numSteps;
						if (progress === 1) {
							wrapperDom.addClass("animation-completed");
						}
					},
				},
				responsive: true,
				cutout: cutoutOffset + "%",
				layout: {
					padding: PIE_OFFSET,
				},
				elements: {
					arc: {
						borderWidth: 0,
					},
				},
				plugins: {
					legend: false,
					tooltip: false,
				},
				onHover: (e) => {
					clickHandler(chart, e);
				},
			},
			data: convertToValidPieData(currentData),
		};

		const ctx = $(this).get(0);
		const chart = new Chart(ctx, config);
		window.doughnutChart.push(chart);
	});
}

function clickHandler(chart, evt) {
	const points = chart.getElementsAtEventForMode(
		evt,
		"nearest",
		{ intersect: true },
		true
	);

	if (points.length) {
		const firstPoint = points[0];
		const label = chart.data.labels[firstPoint.index];
		const value =
			chart.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
		const parent = $(chart.canvas).closest(".chart");
		parent.find(".value-ratio .value").text(formatNumber(value) + "%");
		parent.find(".value-ratio .name").text(label);
		const pieIndex = firstPoint.index;
		const item = $(chart.canvas)
			.closest(".big-chart-wrapper")
			.find(".dropdown-item")
			.eq(pieIndex);
		triggerHover(chart, 0, pieIndex, item, true);
	}
}
function triggerHover(
	chart,
	datasetIndex,
	index,
	item = null,
	autoScrollToActive = false
) {
	const parent = $(chart.canvas).closest(".big-chart-wrapper");
	const dataLength = chart.data.datasets[0].data.length;
	const isExitData = dataLength > index;
	if (!isExitData) {
		$(item).removeClass("active");
		chart.setActiveElements([]);
		chart.update();
		return;
	}

	if (item) {
		$(item).siblings().removeClass("active");
		$(item).addClass("active");
		if (autoScrollToActive) {
			$(item)
				.closest(".dropdown-list")
				.scrollTo(".dropdown-item.active", 10);
		} else {
			const name = $(item).find(".title").text();
			const value = $(item).find(".value").text();
			parent.find(".value-ratio .name").text(name);
			parent.find(".value-ratio .value").text(value);
		}
	}
	chart.setActiveElements([
		{
			datasetIndex: datasetIndex,
			index: index,
		},
	]);
	chart.update();
}

function chartItemInfosOnEnter() {
	$(".big-chart-wrapper").each(function (chartIndex) {
		$(this).on("mouseenter", ".infos .dropdown-item", function () {
			const parent = $(this).closest(".big-chart-wrapper");
			const currentChart = window.doughnutChart[chartIndex];
			const pieIndex = $(this).index();
			if (!currentChart) return;
			triggerHover(currentChart, 0, pieIndex, $(this));
		});
	});
}

function storeInitialChartItemHTML() {
	window.storeInitialItemDom = false;
	if (window.storeInitialItemDom) return;
	let initialDom = $(".big-chart-wrapper .dropdown-item")[0];
	window.storeInitialItemDom = initialDom;
}

function renderChartItemHTML(dateIndex = 0) {
	if (!window.storeInitialItemDom) return;
	if (!window.doughnutChart) return;
	window.doughnutChart.forEach((chart, index) => {
		const cloneHTML = $(window.storeInitialItemDom).clone();
		const data = pieChartRootData[index].dates[dateIndex]?.data || [];
		const parent = $(chart.canvas).closest(".chart");

		parent
			.find(".value-ratio .value")
			.text(data[0]?.data ? formatNumber(data[0]?.data) + "%" : "");
		parent
			.find(".value-ratio .name")
			.text(data[0]?.labels ? data[0]?.labels : "");
		let html = "";
		if (data.length === 0) {
			cloneHTML.find(".title").text("Không có dữ liệu");
			cloneHTML.find(".value").text(0 + "%");
			cloneHTML.css({ "--data-color": "#f00" });
			cloneHTML.addClass("no-data");
			html += cloneHTML.get(0).outerHTML;
		} else {
			data.forEach((item, itemIndex) => {
				let rollColor = pieColors[itemIndex % pieColors.length];
				cloneHTML.find(".title").text(item.labels);
				cloneHTML.find(".value").text(formatNumber(item.data) + "%");
				cloneHTML.css({ "--data-color": rollColor });
				html += cloneHTML.get(0).outerHTML;
			});
		}
		if (!chart.canvas) return;
		// console.log("🟩 ~ window.doughnutChart.forEach ~ html:", html);
		$(chart.canvas)
			.closest(".big-chart-wrapper")
			.find(".dropdown-list")
			.html(html);
	});
}

function renderChartTableHTML(datasetIndex = 0, tabIndex = null) {
	// console.log("🟩 ~ renderChartTableHTML ~ tabIndex:", tabIndex);
	if (!window.doughnutChart) return;
	// $(".danhmucdautu-2 table").find("tbody").html("");
	// $(".danhmucdautu-3 table").find("tbody").html("");
	window.doughnutChart.forEach((chart, index) => {
		const currentTabIndex = tabIndex ? tabIndex : index;
		const table_1 =
			pieChartRootData[currentTabIndex].dates[datasetIndex]?.table_1 ||
			[];
		const table_2 =
			pieChartRootData[currentTabIndex].dates[datasetIndex]?.table_2 ||
			[];

		// console.log("🟩 ~ window.doughnutChart.forEach ~ table_1:", table_1);
		if (table_1.length === 0) {
			$(`.tabslet-content-other[id='tab-${index + 1}'] .table-1`).hide();
		}
		if (table_2.length === 0) {
			$(`.tabslet-content-other[id='tab-${index + 1}'] .table-2`).hide();
		}
		if (table_1.length > 0) {
			$(
				`.tabslet-content-other[id='tab-${index + 1}'] .table-1 tbody`
			).html("");
			// console.log(
			// 	`.tabslet-content-other[id='tab-${index + 1}'] .table-1 table`
			// );
			table_1.forEach((item) => {
				$(
					`.tabslet-content-other[id='tab-${
						index + 1
					}'] .table-1 table`
				)
					.find("tbody")
					.append(
						`<tr>
					<td>${item.content_1}</td>
					<td>${item.content_2}</td>
					<td>${item.content_3}</td>
					<td>${formatNumber(item.content_4)}</td>
				</tr>`
					);
			});
			$(`.tabslet-content-other[id='tab-${index + 1}'] .table-1`).show();
		}
		if (table_2.length > 0) {
			$(
				`.tabslet-content-other[id='tab-${index + 1}'] .table-2 tbody`
			).html("");
			table_2.forEach((item) => {
				$(
					`.tabslet-content-other[id='tab-${
						index + 1
					}'] .table-2 table`
				)
					.find("tbody")
					.append(
						`<tr>
					<td>${item.content_1}</td>
					<td>${formatNumber(item.content_2)}</td>
					<td>${formatNumber(item.content_3)}</td>
				</tr>`
					);
			});
			$(`.tabslet-content-other[id='tab-${index + 1}'] .table-2`).show();
		}
	});
}

function triggerSelectRange() {
	$(".danhmucdautu-1  select").on("change", function () {
		const dateIndex = $(this).val();
		if (dateIndex === "-1") return;
		window.doughnutChart.forEach((chart, index) => {
			const selectedValue =
				pieChartRootData[index].dates[dateIndex] || [];
			if (selectedValue.length === 0) {
				window.doughnutChart[index].data.labels = [];
				window.doughnutChart[index].data.datasets[0].data = [];
			} else {
				window.doughnutChart[index].data.labels =
					selectedValue.data.map((item) => item.labels);
				window.doughnutChart[index].data.datasets[0].data =
					selectedValue.data.map((item) => item.data);
			}
			window.doughnutChart[index].update();
			renderChartItemHTML(dateIndex);
			renderChartTableHTML(dateIndex);
		});
	});
	$(".danhmucdautu-1 .tabslet-tab a").on("click", function () {
		const tabIndex = $(this).parent().index();
		renderChartTableHTML($(".danhmucdautu-1 select").val(), tabIndex);
	});
}

function setElementToScreen() {
	var screenRight = $(".screen-right");
	var screenLeft = $(".screen-left");
	const position = ($(window).width() - $(".container").width()) / 2;
	if ($(window).width() >= 1280) {
		if (screenRight.length) {
			//
			screenRight.each(function () {
				$(this).css({
					"margin-right": -position + "px",
				});
			});
		}
		if (screenLeft.length) {
			//
			screenLeft.each(function () {
				$(this).css({
					"margin-left": -position + "px",
				});
			});
		}
	}
}

function pageIntroduce() {
	$(".collapse-item .top").on("click", function (e) {
		$(this).closest(".item").toggleClass("active");
		$(this).closest(".item").find(".bottom").slideToggle();
	});
}

function checkListItem() {
	$("main ul").each(function () {
		$(this).addClass("list-item-added");
	});
}

var calendarCustom;
var calendarHoliday = [];
calendarHoliday = ["2022-11-10", "2022-11-12", "2022-11-13"];

function calendarInit() {
	if (typeof dev_obj !== "undefined")
		if (dev_obj.calendar_has_event) {
			calendarHoliday = dev_obj.calendar_has_event;
		}
	calendarCustom = new VanillaCalendar("#calendar", {
		actions: {
			clickDay(event, dates) {
				//
			},
		},
		settings: {
			lang: lang[currCulture].languageType,
			visibility: {
				templateHeader: "%M/%Y",
				weekend: false,
				today: true,
				monthShort: false,
			},
			selected: {
				// Khai báo ngày event
				holidays: calendarHoliday,
			},
		},
	});

	calendarCustom.init();
	// $(document).on("click", ".vanilla-calendar-day__btn", function () {
	// 	if (calendarCustom.settings.visibility.today != false) {
	// 		calendarCustom.settings.visibility.today = false;
	// 		calendarCustom.update();
	// 	}
	// });
}

function fancyboxCustom() {
	Fancybox.bind("[data-fancybox-custom]", {
		mainClass: "custom-fancybox-popup",
		template: {
			closeButton: '<i class="fa-light fa-xmark"></i>',
		},
		parentEL: document.head,
	});
	Fancybox.bind("[data-fancybox-member]", {
		mainClass: "popup-content-member",
		template: {
			closeButton: '<i class="fa-light fa-xmark"></i>',
		},
		parentEL: document.head,
	});

	$("body").on("click", ".close-fancybox-custom", function () {
		Fancybox.close();
	});
}
function showNavFilter() {
	const removeActive = () => {
		$(".default-nav.nav-selection").removeClass("active");
		$(".default-nav.nav-selection ul").slideUp();
	};
	$(".default-nav.nav-selection").on("click", function () {
		$(this).toggleClass("active");
		$(this).find("ul").slideToggle();
	});
	$(".default-nav.nav-selection li").on("click", function () {
		$(".default-nav.nav-selection li").removeClass("active");
		$(this).addClass("active");
		var oldTitle = $(this).find("a").text();
		var oldHref = $(this).find("a").attr("href");
		$(this).closest(".default-nav").find(".active-link").text(oldTitle);
		removeActive();
	});
	$(document).click((event) => {
		if (!$(event.target).closest(".default-nav").length) {
			removeActive();
		}
	});

	// $(window).on("scroll", function () {
	// 	removeActive();
	// });
}

function formatNumberInput() {
	document
		.querySelectorAll(".manual-form .form-group.form-number input")
		.forEach(
			(inp) =>
				new Cleave(inp, {
					numeral: true,
					// delimiter: ".",
					numeralDecimalMark: ",",
					delimiter: ".",
					numeralThousandsGroupStyle: "thousand",
				})
		);
}

function getSecondValueAfterSplit(str, splitChar) {
	if (!str) return "";
	const splitStr = str.split(splitChar);

	// Return the second value in the split array, or an empty string if it doesn't exist
	return splitStr[1] || "";
}
function removeDuplicatesArray(arr) {
	return arr.filter((val, index) => arr.indexOf(val) === index);
}
const activeOnScroll = () => {
	// Onload

	// ! Add class scrollToPage menu wp-admin.

	function OnLoadToSection() {
		var path = window.location.href;
		let destination = "#" + path.substr(path.indexOf("#") + 1);
		if ($(destination)?.offset()?.top)
			$("html, body").animate(
				{
					scrollTop: $(destination).offset().top - height_header,
				},
				"slow"
			);

		$(".scrollToPage[class*='current'] .sub-menu li").each(function () {
			var newPath = $(this).find("a").attr("href");
			var newDestination = "#" + newPath.substr(newPath.indexOf("#") + 1);
			if (newDestination == destination) {
				$(this).addClass("active");
			}
		});
	}

	var sectionArray = [];
	$(".scrollToPage[class*='current'] .sub-menu li").each(function () {
		var href = $(this).find("a").attr("href");
		var id = getSecondValueAfterSplit(href, "#");
		sectionArray.push(`${id}`);
	});
	const noDuplicate = removeDuplicatesArray(sectionArray);
	for (var i = 0; i < noDuplicate.length; i++) {
		noDuplicate[i];
	}
	// console.log(noDuplicate);
	$('main section[id*="section-"').each(function (e) {
		$(this).attr("id", noDuplicate[e]);
	});

	// Check if Destination have #sec-
	if (window.location.href.indexOf("#") != -1) {
		OnLoadToSection();
	}
	$(".scrollToPage .sub-menu li a").on("click", function () {
		let path = $(this).attr("href");
		let destination = getSecondValueAfterSplit(path, "#");
		// console.log(destination);
		$(this).parent().siblings().removeClass("active");
		$(this).parent().addClass("active");
		$("html, body").animate(
			{
				scrollTop: $("#" + destination).offset().top - height_header,
			},
			"slow"
		);
	});
};

function aosAnimation() {
	AOS.init({
		disable: "mobile",
		duration: 1000,
		offset: 0,
		delay: 150,
		// once: true,
	});
	AOS.refresh();
}

let currentRangeIndex = null; // Track currently selected range button index

let buttonsRange = [
	{
		range: 1,
		rangeType: "ytd",
		label: "YTD",
	},
	{
		range: 3,
		rangeType: "month",

		label: currCulture === "vi" ? "3 Tháng" : "3 Months",
	},
	{
		range: 6,
		rangeType: "month",
		label: currCulture === "vi" ? "6 Tháng" : "6 Months",
	},
	{
		range: 1,
		rangeType: "year",
		label: currCulture === "vi" ? "1 Năm" : "1 Year",
	},

	{
		range: 3,
		rangeType: "year",
		label: currCulture === "vi" ? "3 Năm" : "3 Year",
	},
	{
		range: 5,
		rangeType: "year",
		label: currCulture === "vi" ? "5 Năm" : "5 Year",
	},
	{
		rangeType: "all",
		label: currCulture === "vi" ? "Tất cả" : "All", //Change it to "All"
	},
];

const rangeIndexToProperty = {
	0: 'ytd',
	1: 'threeMonth',
	2: 'sixMonth',
	3: 'oneYear',
	4: 'threeYear',
	5: 'fiveYear',
	6: 'all'
};

function getPercentagePropertyByRangeIndex(index) {
	if (index === null || index === undefined) {
		return 'all';
	}
	const property = rangeIndexToProperty[index];
	console.log("🚀 ~ getPercentagePropertyByRangeIndex ~ property:", property)
	return property !== undefined ? property : 'all';
}

function stockGraphSetting() {
	window.dataPoints1 = [];
	window.dataPoints2 = [];
}

function dygraphsSetting() {
	dataPoints1 = [];
	dataPoints2 = [];
	const chartTarget = document.getElementById("chart-investment");
	const fontFamily = {
		labelFontFamily: "Anek Latin",
	};
	let isMobile = window.innerWidth < 768;
	const labelSettings = {
		labelFontColor: "#fff",
		labelFontSize: isMobile ? 10 : 14,
		...fontFamily,
	};
	const tickLineGridSettings = {
		lineThickness: 2,
		tickThickness: 0,
		gridDashType: "solid",
		gridThickness: 1,
	};
	const buttonStyles = {
		labelFontSize: 0,
		width: 0,
		padding: 0,
		borderThickness: 0,
	};
	CanvasJS.addColorSet("customColorSet1", [
		"#122F5B",
		"#rgb(174 199 195 / 60%)",
		"#23BFAA",
		"#FAA586",
		"#EB8CC6",
	]);
	if (chartTarget === null) return;
	document.fonts.load("1px Anek Latin").then(function () {
		let valueType = chartTarget.dataset.value;
		let suffix = valueType === "percentage" ? "%" : "";
		CanvasJS.addCultureInfo("vi", {
			days: [
				"Chủ nhật",
				"Thứ 2",
				"Thứ 3",
				"Thứ 4",
				"Thứ 5",
				"Thứ 6",
				"Thứ 7",
			],
			shortDays: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
			months: [
				"Tháng 1",
				"Tháng 2",
				"Tháng 3",
				"Tháng 4",
				"Tháng 5",
				"Tháng 6",
				"Tháng 7",
				"Tháng 8",
				"Tháng 9",
				"Tháng 10",
				"Tháng 11",
				"Tháng 12",
			],
			shortMonths: [
				"Thg 1",
				"Thg 2",
				"Thg 3",
				"Thg 4",
				"Thg 5",
				"Thg 6",
				"Thg 7",
				"Thg 8",
				"Thg 9",
				"Thg 10",
				"Thg 11",
				"Thg 12",
			],
		});
		var stockChart = new CanvasJS.StockChart(chartTarget, {
			theme: "light2", //"light1", "dark1", "dark2"
			backgroundColor: "#051A3A",
			title: "",
			culture: currCulture === "vi" ? "vi" : "en",
			charts: [
				{
					animationEnabled: true,
					axisX: {
						...labelSettings,
						...tickLineGridSettings,
						gridColor: "rgba(255, 255, 255, 0.05)",
						labelAngle: -45,
						labelTextAlign: "right",
						labelAutoFit: true,
						crosshair: {
							color: "rgba(255,255,255,0.5)",
							enabled: true,
							snapToDataPoint: true,
							labelFormatter: function (e) {
								return "";
							},
						},
					},
					axisY: {
						...labelSettings,
						...tickLineGridSettings,
						gridColor: "rgba(255, 255, 255, 0.2)",
						labelFontColor: "#F6E18D",
						labelFormatter: function (e) {
							if (valueType === "percentage") {
								const isInteger = Number.isInteger(e.value);
								return `${
									isInteger ? e.value : e.value.toFixed(2)
								}${suffix}`;
							}
							return convertCurrency(e.value);
						},
						crosshair: {
							color: "rgba(255,255,255,0.5)",
							enabled: true,
							snapToDataPoint: true,
							labelFormatter: function (e) {
								return "";
							},
						},
					},
					toolTip: {
						// shared: true,
						// content: "<span class='tooltips-content'>{y}</span>",
						contentFormatter: function (e) {
							const date = e.entries[0].dataPoint.x;
							let dateFormatted = date;
							if (date) {
								dateFormatted =
									DateTime.fromJSDate(date).toFormat(
										"dd/MM/yyyy"
									);
							}
							let name = e.entries[0].dataSeries.name;
							const propertyKey = getPercentagePropertyByRangeIndex(currentRangeIndex);
							let percentage = e.entries[0].dataPoint?.[propertyKey];
							console.log("🚀 ~ dygraphsSetting ~ dataPoint:", e.entries[0].dataPoint)
							console.log("🚀 ~ dygraphsSetting ~ percentage:", percentage)
							if (percentage === null || percentage === undefined || percentage === '') {
								percentage = 0;
							}
							// console.log("🟩 ~ name:", name);
							let color = e.entries[0].dataSeries.color;

							let multiply_ratio =
								e.entries[0].dataPoint?.multiply_ratio || 1;
							let dataY =
								multiply_ratio === 1
									? e.entries[0].dataPoint.y
									: e.entries[0].dataPoint.y / multiply_ratio;
							let stock_volatility =
								e.entries[0].dataPoint.stock_volatility;
							let value = suffix
								? convertCurrency(stock_volatility)
								: convertCurrency(dataY);
							let currency = `${value} VNĐ`;
							if (name.toLowerCase().includes("vn-index")) {
								currency = `${value}`;
							}
							return `
							<span class="tooltips-wrapper" style="--data-color: ${color}">
								<span class="tooltips-date">${dateFormatted}</span>
								<span class="tooltips-value">
									<span class="tooltips-name">${name}</span>: ${currency} ${
								percentage !== "" && percentage !== null
									? `<span class="tooltips-percentage"> | ${convertNumberFormat(
											percentage
									  )}%</span>`
									: ""
							}
								</span></span>
						`;
						},
						// content: "{name}: ${y}",
					},
					data: [
						{
							type: "spline",
							name: "LHCFC",
							yValueFormatString: "$#,###.##",
							dataPoints: dataPoints1,
							color: "#A89142",
						},
						{
							type: "spline",
							name: "VN-index",
							yValueFormatString: "$#,###.##",
							dataPoints: dataPoints2,
							color: "#AEC7C3",
						},
					],
				},
			],
			navigator: {
				enabled: false,
				height: 48,
				animationEnabled: true,
				backgroundColor: "transparent",
				slider: {
					handleColor: "#fff",
					handleWidth: 8,
					handleHeight: 20,
					handleBorderThickness: 0,
					maskColor: "rgba(18, 47, 91, .4)",
					maskOpacity: 1,
					outlineColor: "#fff",
				},
				axisX: {
					gridColor: "transparent",
					labelFormatter: function (e) {
						return "";
					},
				},
				colorSet: "customColorSet1",
				data: [
					{
						type: "area",
						// color: "#A89142",
						dataPoints: dataPoints1,
					},
					{
						type: "area",
						// color: "#AEC7C3",
						dataPoints: dataPoints2,
					},
				],
			},
			rangeChanged: (e) => {
				// console.log("🟩 ~ e:", e);
				var chart = e.stockChart;
				// var axis = chart.axisX[0];
				// console.log(chart);
				// var visibleRange = axis.viewportMaximum - axis.viewportMinimum;
				// console.log("🟩 ~ visibleRange:", visibleRange);
				updateChartInputFields(e);
				// updateAxisXDateFormat(e);
				if (e.source == "buttons") {
					renderRangeButton(e.index);
					// console.log("rangeChanged");
				}
			},
			rangeChanging: (e) => {
				// console.log("🟩 ~ e:", e);
				updateAxisXDateFormat(e);
				// 	updateChartInputFields(e);
				// 	// if (!window.isFirstLoadChart) return;
				// 	renderRangeButton(e.index);
				// 	// console.log("rangeChanging");
			},
			rangeSelector: {
				label: "",
				buttonStyle: {
					...fontFamily,
					...buttonStyles,
					spacing: 12,
				},
				buttons: [...buttonsRange],
				inputFields: {
					valueFormatString: "DD/MM/YYYY",
					style: {
						backgroundColor: "transparent",
						border: 0,
						fontSize: 0,
					},
				},
				visible: true,
			},
		});

		const newData = chartData;

		for (var i = 0; i < newData.length; i++) {
			dataPoints1.push({
				x: new Date(chartData[i].date),
				y: Number(chartData[i].lhcfc),
			});
			// dataPoints2.push({
			// 	x: new Date(chartData[i].date),
			// 	y: chartData[i].vnindex
			// 		? Number(chartData[i].vnindex)
			// 		: Math.random() * Number(chartData[i].lhcfc) - 0.5,
			// });
		}
		window.stockChart = stockChart;
		renderStockChart();
	});
}

function updateChartRange() {
	const startDateInput = document.getElementById("startDate");
	const endDateInput = document.getElementById("endDate");
	if (!startDateInput || !endDateInput) return null;
	const startDate = new Date(startDateInput.value);
	const endDate = new Date(endDateInput.value);

	if (!isNaN(startDate) && !isNaN(endDate) && startDate <= endDate) {
		if (typeof stockChart.rangeChanged === "function") {
			stockChart.rangeChanged({
				stockChart: stockChart,
				source: "input", // Indicate that the source is the input
			});
			// console.log("🟩 ~ update unactiveRangeButton");
			unactiveRangeButton();
		}
	}
}

function debounce(func, delay) {
	let timeout;
	return function (...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => {
			func.apply(this, args);
		}, delay);
	};
}

function handleInputDateChange() {
	const debouncedUpdateChartRange = debounce(updateChartRange, 300); // 300ms delay
	const startDateInput = document.getElementById("startDate");
	const endDateInput = document.getElementById("endDate");
	if (!startDateInput || !endDateInput) return null;
	startDateInput.addEventListener("change", debouncedUpdateChartRange);
	endDateInput.addEventListener("change", debouncedUpdateChartRange);
}

function updateAxisXDateFormat(e) {
	var hours = 1000 * 60 * 60;
	const maximum = e.maximum;
	const minimum = e.minimum;
	const source = e.source;
	let range = maximum - minimum;
	const diff = range / hours;
	// console.log("🟩 ~ updateAxisXDateFormat ~ range:", range);
	// console.log("🟩 ~ updateAxisXDateFormat ~ diff:", diff);

	// Calculate the range in days
	const rangeInDays = range / (1000 * 60 * 60 * 24);
	// console.log(stockChart.options.charts[0].axisY);
	if (rangeInDays < 365) {
		// If the range is less than 1 year (365 days)
		stockChart.options.charts[0].axisX.valueFormatString = "DD/MM/YYYY"; // Show format dd/mm/yyyy
	} else {
		// If the range is 1 year or more
		stockChart.options.charts[0].axisX.valueFormatString = "MM/YYYY"; // Show format mm/yyyy
	}

	// console.log(
	// 	"🟩 ~ updateAxisXDateFormat ~ stockChart.options.charts[0].axisX.valueFormatString:",
	// 	stockChart.options.charts[0].axisX.valueFormatString
	// );
}

function updateChartInputFields(e) {
	// console.log("🟩 ~ updateChartInputFields ~ e:", e);
	const getEndDate = stockChart.rangeSelector.inputFields.get("endValue");
	const getStartDate = stockChart.rangeSelector.inputFields.get("startValue");
	const endDate = timeStampToDate(getEndDate);
	const startDate = timeStampToDate(getStartDate);
	const validInputDateFormat = "yyyy-MM-dd";
	$(".end-date").val(
		DateTime.fromJSDate(endDate).toFormat(validInputDateFormat)
	);
	$(".start-date").val(
		DateTime.fromJSDate(startDate).toFormat(validInputDateFormat)
	);
	// stockChart.rangeSelector.inputFields.set("startValue", startDate);
	// stockChart.rangeSelector.inputFields.set("endValue", endDate);
}

function changeInputHandler() {
	$(document).on("change", ".input-date-chart", function (e) {
		const data = $(this).val();
		const starDate = $(".start-date").val();
		const endDate = $(".end-date").val();
		// console.log("🟩 ~ endDate:", endDate);
		if (!data) return null;
		if (starDate) {
			stockChart.rangeSelector.inputFields.set(
				"startValue",
				new Date(starDate)
			);
		}
		if (endDate) {
			stockChart.rangeSelector.inputFields.set(
				"endValue",
				new Date(endDate)
			);
		}
	});
}

const timeStampToDate = (timeStamp) => {
	return new Date(timeStamp);
};

function handleRangeButtonClick() {
	$(document).on("click", ".tab-investment .filter a", function (e) {
		e.preventDefault();
		const index = $(this).index();
		currentRangeIndex = index;
		if (!stockChart) return null;
		const button = stockChart.rangeSelector.buttons[index];
		var mockEvent = {
			stockChart: stockChart,
		};
		button.click.call(button, mockEvent);
	});
}

function renderRangeButton(index = buttonsRange.length - 1, forceClick = false) {
	if (buttonsRange && stockChart) {
		// Update current range index tracker
		currentRangeIndex = index;
		
		const mainBtn = $(".tab-investment .filter a").eq(0);
		mainBtn.removeClass("active");
		const btnClass = mainBtn.attr("class");
		// remove active class
		mainBtn.parent().html();
		let btnHTML = "";
		let btnIndex = 0;

		for (const btn of buttonsRange) {
			btnIndex++;
			// Trigger click on first load OR when forceClick is true (tab switch)
			if (btnIndex - 1 === index && (!window.isFirstLoadChart || forceClick)) {
				if (!stockChart) return null;
				const button = stockChart.rangeSelector.buttons[btnIndex - 1];
				if (!button.clickHandled) {
					button.clickHandled = true;
					var mockEvent = {
						stockChart: stockChart,
						stopPropagation: function () {},
						preventDefault: function () {},
					};
					console.log(
						"🟩 ~ renderRangeButton ~ mockEvent.stockChart:",
						mockEvent.stockChart
					);
					button.click.call(button, mockEvent);
					window.isFirstLoadChart = true;
					button.clickHandled = false;
				}
				// Trigger click first button on load
			}

			const isEnable =
				stockChart.rangeSelector.buttons[btnIndex - 1].enabled ===
				false;
			// let isActive = btnIndex - 1 === index;
			// let isActive =
			// 	stockChart.rangeSelector.buttons[btnIndex - 1].state === "on";
			let isActive = btnIndex - 1 === index ? true : false;

			// if (index === null) {
			// 	isActive = false;
			// }
			btnHTML += `<a ${isEnable ? "disabled" : ""} class="${btnClass}${
				isActive ? " active " : ""
			}" data-range="${btn.rangeType}">${btn.label}</a>`;
		}
		mainBtn.parent().html(btnHTML);
	}
}

// Get current range index, returns last index (all) if not set
function getCurrentRangeIndex() {
	return currentRangeIndex !== null ? currentRangeIndex : buttonsRange.length - 1;
}

function unactiveRangeButton() {
	$(".tab-investment .filter a").removeClass("active");
}

function renderStockChart() {
	stockChart.render();
	renderRangeButton();
}

function formatNumber(
	number,
	separator = ".",
	decimal = ",",
	roundedDecimal = 2
) {
	if (number === null || number === undefined) return null;

	// Check if the number is an integer
	const isInteger = Number.isInteger(number);

	// If it's not an integer, round the number to the specified decimal places
	const formattedNumber = isInteger
		? number
		: Number(number).toFixed(roundedDecimal);

	// Split the number into integer and decimal parts
	const parts = formattedNumber.toString().split(".");
	let integerPart = parts[0];
	const decimalPart = parts.length > 1 ? decimal + parts[1] : "";

	// Format the integer part with the specified separator
	integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, separator);

	// Combine the integer and decimal parts
	return integerPart + decimalPart;
}

$(document).ready(function () {
	// ---***--- Global JS ---***---
	globalJS.init();
	checkListItem();

	// ---***--- Header ---***---
	headerFunction.init();

	// ---***--- Body ---***---
	swiperInit();
	counterUpNumber();
	expandItem();
	activeCommonNav();
	setElementToScreen();
	pageIntroduce();
	activeOnScroll();
	// ---***--- Chart ---***---
	// ---***--- Calendar ---***---
	calendarInit();

	// ---***--- Form ---***---
	formatNumberInput();
	// ---***--- Fancybox ---***---
	fancyboxCustom();
	// ---***--- Sticky ---***---
	// getDynamicPreviousMonth();

	// ---***--- Nav Selection ---***---
	showNavFilter();

	// ---***--- AOS ---***---
	aosAnimation();
	tabsletSetting();
	// Stockchart
	stockGraphSetting();
	dygraphsSetting();
	// Pie Chart
	handleRangeButtonClick(); 
	pieChartInit();
	chartItemInfosOnEnter();
	triggerSelectRange();
	storeInitialChartItemHTML();
	renderChartItemHTML();
	// handleInputDateChange(); 
	// changeInputHandler();
});

$(window).resize(function () {
	setLineFirstTime(
		header.find("nav >ul > li.active"),
		header.find("li.active")
	);
	$("html").css({
		"--header-height": header.outerHeight() + "px",
	});
});
$(window).trigger("resize");

// ***** Preload ***** //
document.onreadystatechange = () => {
	if (document.readyState === "complete") {
		/**
		 * Turn on when Deploy
		 */
		headerFunction.movingLineOnLiActive();
		$("html").css({
			"--header-height": header.outerHeight() + "px",
		});
		$("body").addClass("initial-body");
	}
};

const chartData = [
	{
		date: "2022-12-29 13:00:00",
		lhcfc: "10000",
		vnindex: 3000,
	},
	{
		date: "2023-01-05 00:00:00",
		lhcfc: "10166.68",
		vnindex: 5000,
	},
	{
		date: "2023-01-12 00:00:00",
		lhcfc: "10100.64",
	},
	{
		date: "2023-01-19 00:00:00",
		lhcfc: "10192.17",
	},
	{
		date: "2023-01-26 00:00:00",
		lhcfc: "10244.59",
	},
	{
		date: "2023-02-02 00:00:00",
		lhcfc: "10428.7",
	},
	{
		date: "2023-02-09 00:00:00",
		lhcfc: "10388.65",
	},
	{
		date: "2023-02-16 00:00:00",
		lhcfc: "10285.70",
	},
	{
		date: "2023-02-23 00:00:00",
		lhcfc: "10297.93",
	},
	{
		date: "2023-03-02 00:00:00",
		lhcfc: "10331.85",
	},
	{
		date: "2023-03-09 00:00:00",
		lhcfc: "10365.86",
	},
	{
		date: "2023-03-16 00:00:00",
		lhcfc: "10420.69",
	},
	{
		date: "2023-03-23 00:00:00",
		lhcfc: "10410.73",
	},
	{
		date: "2023-03-30 00:00:00",
		lhcfc: "10424.09",
	},
	{
		date: "2023-03-31 00:00:00",
		lhcfc: "10427.90",
	},
	{
		date: "2023-04-06 00:00:00",
		lhcfc: "10478.29",
	},
	{
		date: "2023-04-13 00:00:00",
		lhcfc: "10528.98",
	},
	{
		date: "2023-04-20 00:00:00",
		lhcfc: "10577.19",
	},
	{
		date: "2023-04-27 00:00:00",
		lhcfc: "10567.34",
	},
	{
		date: "2023-04-30 00:00:00",
		lhcfc: "10574.30",
	},
	{
		date: "2023-05-04 00:00:00",
		lhcfc: "10579.56",
	},
	{
		date: "2023-05-11 00:00:00",
		lhcfc: "10727.02",
	},
	{
		date: "2023-05-18 00:00:00",
		lhcfc: "10881.23",
	},
	{
		date: "2023-05-25 00:00:00",
		lhcfc: "10907.65",
	},
	{
		date: "2023-06-01 00:00:00",
		lhcfc: "10990.37",
	},
	{
		date: "2023-06-08 00:00:00",
		lhcfc: "11185.07",
	},
	{
		date: "2023-06-15 00:00:00",
		lhcfc: "11214.70",
	},
	{
		date: "2023-06-22 00:00:00",
		lhcfc: "11244.24",
	},
	{
		date: "2023-06-29 00:00:00",
		lhcfc: "11349.81",
	},
	{
		date: "2023-07-06 00:00:00",
		lhcfc: "11495.60",
	},
	{
		date: "2023-07-13 00:00:00",
		lhcfc: "11561.57",
	},
	{
		date: "2023-07-20 00:00:00",
		lhcfc: "11661.50",
	},
	{
		date: "2023-07-27 00:00:00",
		lhcfc: "11658.97",
	},
	{
		date: "2023-08-03 00:00:00",
		lhcfc: "11707.76",
	},
	{
		date: "2023-08-10 00:00:00",
		lhcfc: "11774.65",
	},
	{
		date: "2023-08-17 00:00:00",
		lhcfc: "11771.65",
	},
	{
		date: "2023-08-24 00:00:00",
		lhcfc: "11647.27",
	},
	{
		date: "2023-08-31 00:00:00",
		lhcfc: "11840.21",
	},
	{
		date: "2023-09-07 00:00:00",
		lhcfc: "11870.16",
	},
	{
		date: "2023-09-14 00:00:00",
		lhcfc: "11990.36",
	},
	{
		date: "2023-09-21 00:00:00",
		lhcfc: "12169.82",
	},
	{
		date: "2023-09-28 00:00:00",
		lhcfc: "12008.71",
	},
	{
		date: "2023-10-03 00:00:00",
		lhcfc: "12009.88",
	},
	{
		date: "2023-10-05 00:00:00",
		lhcfc: "12009.88",
	},
	{
		date: "2023-10-12 00:00:00",
		lhcfc: "11984.43",
	},
	{
		date: "2023-10-19 00:00:00",
		lhcfc: "11959.34",
	},
	{
		date: "2023-10-26 00:00:00",
		lhcfc: "11973.71",
	},
	{
		date: "2023-11-02 00:00:00",
		lhcfc: "12001.43",
	},
	{
		date: "2023-11-09 00:00:00",
		lhcfc: "12162.6",
	},
	{
		date: "2023-11-16 00:00:00",
		lhcfc: "12189.76",
	},
	{
		date: "2023-11-23 00:00:00",
		lhcfc: "12152.68",
	},
	{
		date: "2023-11-30 00:00:00",
		lhcfc: "12140.07",
	},
	{
		date: "2023-12-07 00:00:00",
		lhcfc: "12172.82",
	},
	{
		date: "2023-12-14 00:00:00",
		lhcfc: "12161.97",
	},
	{
		date: "2023-12-21 00:00:00",
		lhcfc: "12260.14",
	},
	{
		date: "2023-12-28 00:00:00",
		lhcfc: "12339.02",
	},
	{
		date: "2024-01-04 00:00:00",
		lhcfc: "12392.65",
	},
	{
		date: "2024-01-11 00:00:00",
		lhcfc: "12385.26",
	},
	{
		date: "2024-01-18 00:00:00",
		lhcfc: "12403.11",
	},
	{
		date: "2024-01-25 00:00:00",
		lhcfc: "12404.36",
	},
	{
		date: "2024-02-01 00:00:00",
		lhcfc: "12435.90",
	},
	{
		date: "2024-02-08 00:00:00",
		lhcfc: "12498.47",
	},
	{
		date: "2024-02-15 00:00:00",
		lhcfc: "12512.21",
	},
	{
		date: "2024-02-22 00:00:00",
		lhcfc: "12590.21",
	},
	{
		date: "2024-02-29 00:00:00",
		lhcfc: "12583.07",
	},
	{
		date: "2024-03-07 00:00:00",
		lhcfc: "12594.44",
	},
	{
		date: "2024-03-14 00:00:00",
		lhcfc: "12611.14",
	},
	{
		date: "2024-03-21 00:00:00",
		lhcfc: "12593.8",
	},
	{
		date: "2024-03-28 00:00:00",
		lhcfc: "12621.8",
	},
	{
		date: "2024-04-04 00:00:00",
		lhcfc: "12600.34",
	},
	{
		date: "2024-04-11 00:00:00",
		lhcfc: "12598.34",
	},
	{
		date: "2024-04-18 00:00:00",
		lhcfc: "12609.33",
	},
	{
		date: "2024-04-25 00:00:00",
		lhcfc: "12687.95",
	},
	{
		date: "2024-05-02 00:00:00",
		lhcfc: "12717.35",
	},
	{
		date: "2024-05-09 00:00:00",
		lhcfc: "12712.6",
	},
	{
		date: "2024-05-16 00:00:00",
		lhcfc: "12710.92",
	},
	{
		date: "2024-05-23 00:00:00",
		lhcfc: "12725.84",
	},
	{
		date: "2024-05-30 00:00:00",
		lhcfc: "12693.57",
	},
	{
		date: "2024-06-06 00:00:00",
		lhcfc: "12725.78",
	},
	{
		date: "2024-06-13 00:00:00",
		lhcfc: "12772.26",
	},
	{
		date: "2024-06-20 00:00:00",
		lhcfc: "12751.08",
	},
	{
		date: "2024-06-27 00:00:00",
		lhcfc: "12725.76",
	},
	{
		date: "2024-07-04 00:00:00",
		lhcfc: "12779.30",
	},
	{
		date: "2024-07-11 00:00:00",
		lhcfc: "12806.08",
	},
	{
		date: "2024-07-18 00:00:00",
		lhcfc: "13087.88",
	},
	{
		date: "2024-07-25 00:00:00",
		lhcfc: "13022.77",
	},
	{
		date: "2024-08-01 00:00:00",
		lhcfc: "13086.75",
	},
	{
		date: "2024-08-08 00:00:00",
		lhcfc: "12999.01",
	},
	{
		date: "2024-08-15 00:00:00",
		lhcfc: "13263.17",
	},
	{
		date: "2024-08-22 00:00:00",
		lhcfc: "13320.81",
	},
	{
		date: "2024-08-29 00:00:00",
		lhcfc: "13269.84",
	},
	{
		date: "2024-09-05 00:00:00",
		lhcfc: "13256.10",
	},
	{
		date: "2024-09-12 00:00:00",
		lhcfc: "13279.51",
	},
	{
		date: "2024-09-19 00:00:00",
		lhcfc: "13412.60",
	},
	{
		date: "2024-09-26 00:00:00",
		lhcfc: "13430.12",
	},
	{
		date: "2024-10-03 00:00:00",
		lhcfc: "13400.62",
	},
	{
		date: "2025-09-01 00:00:00",
		lhcfc: "13400.62",
	},
];
